
import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  const { isAuthenticated, logout, user } = useAuth();

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-[300px] sm:w-[400px] z-[9999] bg-background border-l">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        
        <div className="flex flex-col space-y-4 mt-6">
          <Link 
            to="/" 
            className="text-lg font-medium hover:text-primary transition-colors py-2"
            onClick={onClose}
          >
            Home
          </Link>
          
          {!isAuthenticated && (
            <>
              <Link 
                to="/demo" 
                className="text-lg font-medium hover:text-primary transition-colors py-2"
                onClick={onClose}
              >
                Demo
              </Link>
              
              <Link 
                to="/faq" 
                className="text-lg font-medium hover:text-primary transition-colors py-2"
                onClick={onClose}
              >
                FAQ
              </Link>
              
              <Link 
                to="/testimonials" 
                className="text-lg font-medium hover:text-primary transition-colors py-2"
                onClick={onClose}
              >
                Testimonials
              </Link>
            </>
          )}
          
          <Link 
            to="/contact" 
            className="text-lg font-medium hover:text-primary transition-colors py-2"
            onClick={onClose}
          >
            Contact
          </Link>

          {isAuthenticated && (
            <Link 
              to="/dashboard" 
              className="text-lg font-medium hover:text-primary transition-colors py-2"
              onClick={onClose}
            >
              My Dashboard
            </Link>
          )}
          
          <div className="border-t pt-4 mt-6">
            {isAuthenticated ? (
              <div className="space-y-4">
                <Link 
                  to="/profile" 
                  className="text-lg font-medium hover:text-primary transition-colors py-2 block"
                  onClick={onClose}
                >
                  Profile
                </Link>
                <Button 
                  variant="outline" 
                  onClick={handleLogout}
                  className="w-full mt-4"
                >
                  Logout
                </Button>
              </div>
            ) : (
              <div className="space-y-4">
                <Link to="/login" onClick={onClose}>
                  <Button variant="outline" className="w-full">
                    Login
                  </Button>
                </Link>
                <Link to="/signup" onClick={onClose}>
                  <Button className="w-full">
                    Sign Up
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
